import { ArrowDownS16 } from '@cian/ui-kit';
import cn from 'classnames';
import { EBehavior } from '../../../../../../enums/EBehavior';
import { memoWithDisplayName } from '../../../../../../helpers/memoWithDisplayName';
import { PartialLabelCheckbox } from '../../../../../PartialLabelCheckbox';
import styles from './NestedCheckboxGroupTitleDesktop.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NestedCheckboxGroupTitleDesktop = memoWithDisplayName(function (props) {
  var open = props.open,
      value = props.value,
      label = props.label,
      onToggleClick = props.onToggleClick,
      onCheckboxClick = props.onCheckboxClick,
      behavior = props.behavior;

  var labelView = function () {
    switch (behavior) {
      case EBehavior.Multiply:
        return /*#__PURE__*/_jsx(PartialLabelCheckbox, {
          label: label,
          value: value
        });

      case EBehavior.Single:
      case EBehavior.SingleInOneGroup:
        return label;
    }
  }();

  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles['container'], open && styles['open']),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['partial-label-checkbox-wrapper'],
      onClick: onCheckboxClick,
      children: labelView
    }), /*#__PURE__*/_jsx("button", {
      className: styles['toggle-button'],
      type: "button",
      onClick: onToggleClick,
      children: /*#__PURE__*/_jsx("div", {
        className: styles['toggle-button-icon-wrapper'],
        children: /*#__PURE__*/_jsx(ArrowDownS16, {
          color: "primary_100"
        })
      })
    })]
  });
}, 'NestedCheckboxGroupTitleDesktopProps');